<button class="table__reset"
        (click)="resetSorting()">
  <svg-icon name="icon-reset-sorting"
            size="11"></svg-icon>
</button>
